
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Strategy } from "@/types/strategy-types";
import { toast } from "@/components/ui/use-toast";
import { useStripePayment } from "./useStripePayment";
import { useManualPayment } from "./useManualPayment";
import { useStrategyTransform } from "./useStrategyTransform";

interface UsePaymentProcessorProps {
  strategy?: Strategy;
  isYearly?: boolean;
}

export const usePaymentProcessor = ({ strategy, isYearly }: UsePaymentProcessorProps) => {
  const navigate = useNavigate();
  const [isProcessing, setIsProcessing] = useState(false);
  const [paymentError, setPaymentError] = useState<string | null>(null);
  const amount = isYearly ? "290" : "29";
  const { transformStrategy } = useStrategyTransform();

  const { handleStripePayment } = useStripePayment({
    strategy,
    isYearly,
    transformStrategy,
    setIsProcessing,
    setPaymentError,
    navigate
  });

  const { handleManualPayment } = useManualPayment({
    strategy,
    isYearly,
    transformStrategy,
    setIsProcessing,
    setPaymentError,
    navigate
  });

  return {
    amount,
    isProcessing,
    paymentError,
    handleStripeSubmit: handleStripePayment,
    handleManualSubmit: handleManualPayment,
    setPaymentError
  };
};
